import { Icon, IconProps } from '@chakra-ui/react';
import { MapPin } from '@phosphor-icons/react';

export const fillStyle = {
  type: 'fill' as const,
  paint: {
    'fill-outline-color': 'rgba(0,0,0,1)',
    'fill-color': '#66c2a5',
    'fill-opacity': 0.6,
  },
};
export const lineStyle = {
  type: 'line' as const,
  paint: {
    'line-width': 2,
    'line-color': 'rgba(0,0,0,.2)',
  },
};
export const getMarkerIconProps = (selected = false) =>
  selected
    ? {
        iconSize: 42,
        iconColor: 'red.500',
      }
    : {
        iconSize: 36,
        iconColor: 'success.500',
      };

export const MarkerIcon = ({
  selected = false,
  ...rest
}: {
  selected: boolean;
} & IconProps) => (
  <Icon
    color={getMarkerIconProps(selected).iconColor}
    weight="fill"
    as={MapPin}
    boxSize={`${getMarkerIconProps(selected).iconSize}px`}
    {...rest}
  />
);
